<template>
  <div>
    <el-form
      v-for="(formData, index) in formDataItems"
      ref="form"
      :key="index"
      :model="formData"
      :rules="rules"
      size="small"
      class="edit-category-options-form"
    >
      <div class="d-flex flex-row">
        <div style="padding-right: 12px" v-if="canDelete">
          <el-form-item>
            <template #label>
              <div><br /></div>
            </template>

            <el-tooltip
              effect="dark"
              :content="$l('INDEX.btn_tips_del') || '删除'"
              placement="top"
            >
              <i
                class="el-icon-delete text-danger tool-btn"
                @click="deleteItem(index)"
              />
            </el-tooltip>
          </el-form-item>
        </div>

        <div class="flex-grow-1">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_categoryOptionNo') || '代码'"
                prop="categoryOptionNo"
              >
                <el-input
                  v-model="formData.categoryOptionNo"
                  :placeholder="
                    $l('form_placeholder_categoryOptionNo') || '请输入代码'
                  "
                  :maxlength="50"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_categoryOptionNameEn') || '英文名称'"
                prop="categoryOptionNameEn"
              >
                <el-input
                  v-model="formData.categoryOptionNameEn"
                  :placeholder="
                    $l('form_placeholder_categoryOptionNameEn') ||
                    '请输入英文名称'
                  "
                  :maxlength="50"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_categoryOptionName') || '中文名称'"
                prop="categoryOptionName"
              >
                <el-input
                  v-model="formData.categoryOptionName"
                  :placeholder="
                    $l('form_placeholder_categoryOptionName') ||
                    '请输入中文名称'
                  "
                  :maxlength="50"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_categoryOptionDesc') || '中文描述'"
                prop="categoryOptionDesc"
              >
                <el-input
                  v-model="formData.categoryOptionDesc"
                  :placeholder="
                    $l('form_placeholder_categoryOptionDesc') ||
                    '请输入中文描述'
                  "
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  :maxlength="500"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_categoryOptionDescEn') || '英文描述'"
              >
                <el-input
                  v-model="formData.categoryOptionDescEn"
                  :placeholder="
                    $l('form_placeholder_categoryOptionDescEn') ||
                    '请输入英文描述'
                  "
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  :maxlength="500"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div class="edit-category-options-add-form">
      <span @click="addItem()">{{ $l('btn_addCategoryOptions') }}</span>
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initFormData = {
  categoryOptionNo: '',
  categoryOptionName: '',
  categoryOptionNameEn: '',
  categoryOptionDesc: '',
  categoryOptionDescEn: '',
}

import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    dfDefinitionCode: { type: String, default: '' },
    dfCategoryNo: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formDataItems: [{ ...initFormData }],
      rules: {
        categoryOptionNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_categoryOptionNo') || '请输入代码',
            trigger: 'blur',
          },
        ],
        categoryOptionName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_categoryOptionName') ||
              '请输入中文名称',
            trigger: 'blur',
          },
        ],
        categoryOptionNameEn: [
          {
            required: true,
            message:
              this.$l('form_placeholder_categoryOptionNameEn') ||
              '请输入英文名称',
            trigger: 'blur',
          },
        ],
        categoryOptionDesc: [
          {
            required: true,
            message:
              this.$l('form_placeholder_categoryOptionDesc') ||
              '请输入中文描述',
            trigger: 'blur',
          },
        ],
        categoryOptionDescEn: [
          {
            required: true,
            message:
              this.$l('form_placeholder_categoryOptionDescEn') ||
              '请输入英文描述',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    canDelete() {
      return this.formDataItems.length > 1
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.dfDefinitionCode || !this.dfCategoryNo) return

      this.loadingOpen()
      const res = await this.$api
        .dfDefinitionCategoryListApi({
          dfDefinitionCode: this.dfDefinitionCode,
          dfCategoryNo: this.dfCategoryNo,
        })
        .catch(() => null)
      this.loadingClose()

      const items = res?.body?.data || []
      if (lodash.isEmpty(items)) this.formDataItems = [{ ...initFormData }]
      else this.formDataItems = items
    },
    addItem() {
      this.formDataItems.push({ ...initFormData })
    },
    async deleteItem(index) {
      if (!this.canDelete) return

      const title = [
        'tips_confirm_categoryOptions_deleteItem',
        this.dfCategoryNo,
      ]
        .filter(Boolean)
        .join('_')

      const confirm = await this.$confirm(
        this.$l(title),
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.formDataItems.splice(index, 1)
    },
    async formValidate() {
      if (!this.formDataItems?.length) {
        this.$message.error(
          this.$l(
            ['tips_editCategoryOptions_empty_error', this.dfCategoryNo]
              .filter(Boolean)
              .join('_')
          )
        )
        return false
      }

      const formItems = this.$refs.form
      const result = await validate.formValidate(formItems)
      if (!result) return false

      const duplicate = lodash.first(
        lodash.flatten(
          lodash.filter(
            lodash.groupBy(this.formDataItems, 'categoryOptionNo'),
            (items) => items.length > 1
          )
        )
      )

      const categoryOptionNo = duplicate?.categoryOptionNo
      if (categoryOptionNo) {
        this.$message.warning(`代码【${categoryOptionNo}】重复，请检查`)
        return false
      }

      return true
    },
    async save() {
      if (!(await this.formValidate())) return (this.backDialogVisible = false)

      const params = {
        dfDefinitionCode: this.dfDefinitionCode,
        categorys: [
          { dfCategoryNo: this.dfCategoryNo, options: this.formDataItems },
        ],
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .dfDefinitionCategorySaveApi(params)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .edit-category-options-form {
    background-color: #f4f6f9;
    padding: 12px;
    padding-bottom: 2px;
    border-radius: 5px;
    margin-bottom: 12px;
    .tool-btn {
      font-size: 22px;
    }

    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner {
      color: #606266 !important;
      background-color: #fff !important;
      border: 1px solid #dcdfe6 !important;
    }
  }
  .edit-category-options-form:last-child {
    margin-bottom: 0;
  }
}

.edit-category-options-add-form {
  margin: 16px 0;

  span {
    font-size: 16px;
    font-weight: bold;
    color: #007bff;
    cursor: pointer;
  }
}
</style>
